import type { Txn } from '../transactions/transactionWire'

/** The rows one "Set all N at once?" prompt covers, and the bank description they share. */
export type SameDescription = { raw: string; rows: Txn[] }

/**
 * The No merchant page's one prompt: the largest group of two or more rows that share the bank's raw
 * description, or null. Only rows a merchant can be set on count — no merchant yet, and not pending
 * (a pending row's merchant is not editable). Descriptions are compared exactly, less surrounding
 * spaces; a tie goes to the group whose first row comes first in the list, so the prompt does not
 * jump between equal groups as the page re-renders.
 */
export function largestSameDescription(rows: readonly Txn[]): SameDescription | null {
  const groups = new Map<string, Txn[]>()
  for (const r of rows) {
    if (r.merchantId !== null || r.isPending) continue
    const key = r.raw.trim()
    if (key === '') continue
    const g = groups.get(key)
    if (g === undefined) groups.set(key, [r])
    else g.push(r)
  }
  let best: SameDescription | null = null
  // Map iteration is insertion order: the first row's group is met first and keeps a tie.
  for (const [raw, g] of groups) {
    if (g.length >= 2 && (best === null || g.length > best.rows.length)) best = { raw, rows: g }
  }
  return best
}
